var canvas, canvas2,text,fontSize, fontFamily, fSize, activeCOLOR, newText, zoom, cWidth = 724, cHeight = 1024,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,img,
    placeholderimg1, placeholderimg2, placeholderimg3,
    placeholderimg4, placeholderimg5, placeholderimg6, placeholderimg7, placeholderimg8, placeholderimg9, placeholderimg10, placeholderimg11, placeholderimg12, placeholderimg13, img,
    leftMarker, rightMarker,clipCircle, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var sizeB1W = 292, sizeB1H = 292,
    sizeB2W = 164, sizeB2H = 187,
    sizeB3W = 164, sizeB3H = 187,
    sizeB4W = 164, sizeB4H = 187,
    sizeB5W = 164, sizeB5H = 187,
    sizeB6W = 164, sizeB6H = 187,
    sizeB7W = 164, sizeB7H = 187,
    sizeB8W = 164, sizeB8H = 187,
    sizeB9W = 164, sizeB9H = 187,
    sizeB10W = 164, sizeB10H = 187,
    sizeB11W = 164, sizeB11H = 187,
    sizeB12W = 164, sizeB12H = 187,
    sizeB13W = 164, sizeB13H = 187,
    circledBox = false;

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');




window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});



let baby_feet = document.querySelector("#baby_feet");
let babyfeet = new fabric.Image(baby_feet, {
  left: 335,   
  top: 240,
  scaleX: 0.07,
  scaleY: 0.07,
  selectable: false
});


let backImg = document.querySelector("#background_image");
let backgroundImage = new fabric.Image(backImg, {
  left: 0,
  top: 0,
  scaleX: 2,
  scaleY: 2,
  selectable: false
});

window['canvas2'].add(babyfeet);
window['canvas2'].add(backgroundImage);
addModify(window['canvas2']);




window['placeholderimg1'] = new fabric.Circle({
  left: 405 + sizeB1W / 2,
  top: 25 + sizeB1H / 2,
  radius: Math.min(sizeB1W, sizeB1H) / 2,
  fill: 'rgba(0,0,0,0.1)',
  selectable: false
});


window['placeholderimg2'] = new fabric.Rect({
  left: 109,
  top: 433.5,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'rgba(0,0,0,0.1)'
});

const placeholderText1 = new fabric.Text('1', {
  left: 109,
  top: 433.5,
  fontSize: 40,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas2'].add(placeholderText1);

window['text3Page'] = new fabric.Text('1st Month',{
  left: 109,
  top: 547,
  fontSize: 24,
  fontFamily: 'Arial',
  fill: 'black'
});

window['canvas2'].add(window['text3Page']);

window['placeholderimg3'] = new fabric.Rect({
  left: 277,
  top: 433.5,
  width: sizeB3W,
  height: sizeB3H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText2 = new fabric.Text('2', {
  left: 277,
  top: 433.5,
  fontSize: 40,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas2'].add(placeholderText2);

window['text4Page'] = new fabric.Text('2nd Month',{
  left: 277,
  top: 547,
  fontSize: 24,
  fontFamily: 'Arial',
  fill: 'black'
});

window['canvas2'].add(window['text4Page']);

window['placeholderimg4'] = new fabric.Rect({
  left: 446,
  top: 433.5,
  width: sizeB4W,
  height: sizeB4H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText3 = new fabric.Text('3', {
  left: 446,
  top: 433.5,
  fontSize: 40,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas2'].add(placeholderText3);

window['text5Page'] = new fabric.Text('3rd Month',{
  left: 446,
  top: 547,
  fontSize: 24,
  fontFamily: 'Arial',
  fill: 'black'
});

window['canvas2'].add(window['text5Page']);

window['placeholderimg5'] = new fabric.Rect({
  left: 615,
  top: 433.5,
  width: sizeB5W,
  height: sizeB5H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText4 = new fabric.Text('4', {
  left: 615,
  top: 433.5,
  fontSize: 40,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas2'].add(placeholderText4);

window['text6Page'] = new fabric.Text('4th Month',{
  left: 615,
  top: 547,
  fontSize: 24,
  fontFamily: 'Arial',
  fill: 'black'
});

window['canvas2'].add(window['text6Page']);

window['placeholderimg6'] = new fabric.Rect({
  left: 109,
  top: 658.5,
  width: sizeB6W,
  height: sizeB6H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText5 = new fabric.Text('5', {
  left: 109,
  top: 658.5,
  fontSize: 40,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas2'].add(placeholderText5);

window['text7Page'] = new fabric.Text('5th Month',{
  left: 109,
  top: 770,
  fontSize: 24,
  fontFamily: 'Arial',
  fill: 'black'
});

window['canvas2'].add(window['text7Page']);

window['placeholderimg7'] = new fabric.Rect({
  left: 277,
  top: 658.5,
  width: sizeB7W,
  height: sizeB7H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText6 = new fabric.Text('6', {
  left: 277,
  top: 658.5,
  fontSize: 40,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas2'].add(placeholderText6);

window['text8Page'] = new fabric.Text('6th Month',{
  left: 277,
  top: 770,
  fontSize: 24,
  fontFamily: 'Arial',
  fill: 'black'
});

window['canvas2'].add(window['text8Page']);


window['placeholderimg8'] = new fabric.Rect({
  left: 446,
  top: 658.5,
  width: sizeB8W,
  height: sizeB8H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText7 = new fabric.Text('7', {
  left: 446,
  top: 658.5,
  fontSize: 40,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas2'].add(placeholderText7);

window['text9Page'] = new fabric.Text('7th Month',{
  left: 446,
  top: 770,
  fontSize: 24,
  fontFamily: 'Arial',
  fill: 'black'
});

window['canvas2'].add(window['text9Page']);

window['placeholderimg9'] = new fabric.Rect({
  left: 615,
  top: 658.5,
  width: sizeB9W,
  height: sizeB9H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText8 = new fabric.Text('8', {
  left: 615,
  top: 658.5,
  fontSize: 40,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas2'].add(placeholderText8);

window['text10Page'] = new fabric.Text('8th Month',{
  left: 615,
  top: 770,
  fontSize: 24,
  fontFamily: 'Arial',
  fill: 'black'
});

window['canvas2'].add(window['text10Page']);

window['placeholderimg10'] = new fabric.Rect({
  left: 109,
  top:881.5,
  width: sizeB10W,
  height: sizeB10H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText9 = new fabric.Text('9', {
  left: 109,
  top:881.5,
  fontSize: 40,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas2'].add(placeholderText9);

window['text11Page'] = new fabric.Text('9th Month',{
  left: 109,
  top: 992,
  fontSize: 24,
  fontFamily: 'Arial',
  fill: 'black'
});

window['canvas2'].add(window['text11Page']);

window['placeholderimg11'] = new fabric.Rect({
  left: 277,
  top:881.5,
  width: sizeB11W,
  height: sizeB11H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText10 = new fabric.Text('10', {
  left: 277,
  top:881.5,
  fontSize: 40,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas2'].add(placeholderText10);

window['text12Page'] = new fabric.Text('10th Month',{
  left: 277,
  top: 992,
  fontSize: 24,
  fontFamily: 'Arial',
  fill: 'black'
});

window['canvas2'].add(window['text12Page']);


window['placeholderimg12'] = new fabric.Rect({
  left: 446,
  top:881.5,
  width: sizeB12W,
  height: sizeB12H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText11 = new fabric.Text('11', {
  left: 446,
  top:881.5,
  fontSize: 40,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas2'].add(placeholderText11);

window['text13Page'] = new fabric.Text('11th Month',{
  left: 446,
  top: 992,
  fontSize: 24,
  fontFamily: 'Arial',
  fill: 'black'
});

window['canvas2'].add(window['text13Page']);


window['placeholderimg13'] = new fabric.Rect({
  left: 615,
  top:881.5,
  width: sizeB13W,
  height: sizeB13H,
  fill: 'rgba(0,0,0,0.1)',
});

const placeholderText12 = new fabric.Text('12', {
  left: 615,
  top:881.5,
  fontSize: 40,
  fontFamily: 'Arial',
  fill: '#555',
  originX: 'center',
  originY: 'center',
  selectable: false
});

window['canvas2'].add(placeholderText12);

window['text14Page'] = new fabric.Text('12th Month',{
  left: 615,
  top: 992,
  fontSize: 24,
  fontFamily: 'Arial',
  fill: 'black'
});

window['canvas2'].add(window['text14Page']);


window['canvas2'].add(window['placeholderimg1'], window['placeholderimg2'], window['placeholderimg3'], window['placeholderimg4'], window['placeholderimg5'], window['placeholderimg6'], window['placeholderimg7'], window['placeholderimg8'], window['placeholderimg9'], window['placeholderimg10'], window['placeholderimg11'], window['placeholderimg12'], window['placeholderimg13']);


/*document.getElementById('image_upload_first').addEventListener('change', function (e) {
     canvas = window['canvas2'];
     availableHeight = sizeB1H;
     availableWidth = sizeB1W;
     radius = Math.min(availableWidth, availableHeight);

  circledBox = true;

     file = e.target.files[0];
    if (!file) return;

     reader = new FileReader();
    reader.onload = function (event) {
        fabric.Image.fromURL(event.target.result, function (img) {
            img.scaleToWidth(availableWidth);
            img.scaleToHeight(availableHeight);

            // Create a circular clipPath with same origin as image
             clipCircle = new fabric.Circle({
                radius: radius * (5 / 2),
                originX: 'center',
                originY: 'center'
            });

            // Set position and clipping
            img.set({
                left: 405 + sizeB1W / 2,
                top: 25 + sizeB1H / 2,
                originX: 'center',
                originY: 'center',
                clipPath: clipCircle,
                selectable: false
            });

            // Replace old image
            canvas.remove(window['placeholderimg1']);
            window['placeholderimg1'] = img; // update global reference
            canvas.add(img);
            canvas.renderAll();

            // Optional: trigger recrop UI or functionality
          sizeCrop = '1';
            reCroper = jQuery(e.target).parent().next().find('.btnReCrop').attr('data-height', availableHeight);
            readURL2(e.target);
        });
    };

    reader.readAsDataURL(file);
});*/

document.getElementById('image_upload_first').addEventListener('change',function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg1'];
  available_height = img.height;
  sizeCrop = '1';
  circledBox = 'DoIt';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height).attr('data-circle',circledBox);
  readURL2(e.target,'#image1');
});

var circleimg,circleBorder,imgRatio,clipRatio,clipWidth = 292;
    circlePathString = "M400,799L400,799C179.6,799,1,620.4,1,400v0C1,179.6,179.6,1,400,1h0c220.4,0,399,178.6,399,399v0 C799,620.4,620.4,799,400,799z";
var circleClip = new fabric.Path(circlePathString, {
  left: 551,
  top: 171,
  originX: 'center',
  originY: 'center',
  flipY: true,
  fill: 'transparent',
  absolutePositioned: true
});
circleClip.scaleToWidth(clipWidth);

fabric.Image.fromURL('https://cdn.shopify.com/s/files/1/0796/4452/4821/files/anniversary_placeholder.png?v=1741253729', function(circleimg){
  circleimg.set({ crossOrigin: 'anonymous' });
  circleimg.set({
    left: 551,
    top: 171,
    originX: 'center',
    originY: 'center',
    selectable: false,
    clipPath: circleClip
  });

  //canvas2.add(circleimg);

  circleBorder = new fabric.Path(circlePathString, {
    left: 551,
    top: 171,
    originX: 'left',
    originY: 'top',
    fill: 'transparent',
    flipY: true,
    stroke: 'red',
    strokeWidth: 0,
    selectable: false
  });
  circleBorder.scaleToWidth(clipWidth);
  canvas2.renderAll();
}, { crossOrigin: 'anonymous' });

document.getElementById('image_upload_second').addEventListener('change',function(e){
  canvas = window['canvas2'];
  available_height = sizeB2H;
  img = window['placeholderimg2'];
  sizeCrop = '0.88';
  circledBox = 'No';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height).attr('data-circle',circledBox);
  readURL2(e.target);
});

document.getElementById('image_upload_third').addEventListener('change',function(e){
  canvas = window['canvas2'];
  available_height = sizeB3H;
  img = window['placeholderimg3'];
  sizeCrop = '0.88';
  circledBox = 'No';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height).attr('data-circle',circledBox);
  readURL2(e.target);
});

document.getElementById('image_upload_fourth').addEventListener('change',function(e){
  canvas = window['canvas2'];
  available_height = sizeB4H;
  img = window['placeholderimg4'];
  sizeCrop = '0.88';
  circledBox = 'No';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height).attr('data-circle',circledBox);
  readURL2(e.target);
});

document.getElementById('image_upload_fifth').addEventListener('change', function(e){
  canvas = window['canvas2'];
  available_height = sizeB5H;
  img = window['placeholderimg5'];
  sizeCrop = '0.88';
  circledBox = 'No';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height).attr('data-circle',circledBox);
  readURL2(e.target);
});

document.getElementById('image_upload_Sixth').addEventListener('change', function(e){
  canvas = window['canvas2'];
  available_height = sizeB6H;
  img = window['placeholderimg6'];
  sizeCrop = '0.88';
  circledBox = 'No';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height).attr('data-circle',circledBox);
  readURL2(e.target);
});

document.getElementById('image_upload_Seventh').addEventListener('change', function(e){
  canvas = window['canvas2'];
  available_height = sizeB7H;
  img = window['placeholderimg7'];
  sizeCrop = '0.88';
  circledBox = 'No';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height).attr('data-circle',circledBox);
  readURL2(e.target);
});

document.getElementById('image_upload_Eighth').addEventListener('change', function(e){
  canvas = window['canvas2'];
  available_height = sizeB8H;
  img = window['placeholderimg8'];
  sizeCrop = '0.88';
  circledBox = 'No';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height).attr('data-circle',circledBox);
  readURL2(e.target);
});

document.getElementById('image_upload_Ninth').addEventListener('change', function(e){
  canvas = window['canvas2'];
  available_height = sizeB9H;
  img = window['placeholderimg9'];
  sizeCrop = '0.88';
  circledBox = 'No';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height).attr('data-circle',circledBox);
  readURL2(e.target);
});

document.getElementById('image_upload_Tenth').addEventListener('change', function(e){
  canvas = window['canvas2'];
  available_height = sizeB10H;
  img = window['placeholderimg10'];
  sizeCrop = '0.88';
  circledBox = 'No';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height).attr('data-circle',circledBox);
  readURL2(e.target);
});

document.getElementById('image_upload_Eleventh').addEventListener('change', function(e){
  canvas = window['canvas2'];
  available_height = sizeB11H;
  img = window['placeholderimg11'];
  sizeCrop = '0.88';
  circledBox = 'No';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height).attr('data-circle',circledBox);
  readURL2(e.target);
});

document.getElementById('image_upload_Twelveth').addEventListener('change', function(e){
  canvas = window['canvas2'];
  available_height = sizeB12H;
  img = window['placeholderimg12'];
  sizeCrop = '0.88';
  circledBox = 'No';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height).attr('data-circle',circledBox);
  readURL2(e.target);
});

document.getElementById('image_upload_Thirteenth').addEventListener('change', function(e){
  canvas = window['canvas2'];
  available_height = sizeB13H;
  img = window['placeholderimg13'];
  sizeCrop = '0.88';
  circledBox = 'No';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height).attr('data-circle',circledBox);
  readURL2(e.target);
});

window['text1Page'] = new fabric.Text('check',{
  left: 205,
  top: 90,
  fontSize: 75,
  fontFamily: 'Happy Birthday',
  textAlign: 'left',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

var fontName = window['text1Page'].fontFamily;
jQuery('.choose_font').val("'" + fontName + "'").trigger('change');

// Add to canvas
window['canvas2'].add(window['text1Page']);

// Clear text on input focus if default
document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === 'Hassan Minhas') {
    window['text1Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});

// Fit text within a specific width
function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 80; // Start from larger size
  textObj.set({ fontSize });

  // Repeatedly shrink font until it fits
  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// Update text live and auto-fit width
document.getElementById('text_1').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text1Page'].set('text', newText);
  fitTextToWidth(window['text1Page'], 340); // ← adjust width as needed
  window['text1Page'].bringToFront();
  window['canvas2'].renderAll();
});

var maxWidth = 260;
var maxHeight = 300;


window['text2Page'] = new fabric.Text('check',{
  left: 165,
  top: 230,
  width: 290,
  fontSize: 55,
  textAlign: 'left',
  fontFamily: 'Happy Birthday',
  fill: '#000',
  isWrapping: true
});

var fontName2 = window['text2Page'].fontFamily;
jQuery('.choose_font2').val("'" + fontName2 + "'").trigger('change');

window['canvas2'].add(window['text2Page']);

var minFontSize = 20;
var maxFontSize = 55;

// Clear text on input focus if default
document.getElementById('text_2').addEventListener('focus', function () {
  if (window['text2Page'].text === 'My First Year\n28-02-2024') {
    window['text2Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});

// Helper: Adjust font size to fit both width and height
function autoFitText(textbox, maxW, maxH) {
  let fontSize = maxFontSize;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_2').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text2Page'].set({
    text: input
  });
  //fitTextToWidth(window['text2Page'], maxWidth);
  fitTextToBox(window['text2Page'], maxWidth, maxHeight);
});

function fitTextToBox(textObj, maxWidth, maxHeight) {
  let fontSize = maxFontSize;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth || textObj.height > maxHeight;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  // jQuery(window).on('load',function(){
  //   canvasBlock(canvas);
  //   loadFirstImg();
  // });

  jQuery(window).on('resize',function(){
    canvasBlock(canvas);
  });
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}

initCropper();

function readURL2(input){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
      });
      canvas.add(img);
    };
  };
  reader.readAsDataURL(file);
}

function addCroppedImg(imgurl){
  canvas.remove(img).renderAll();
  if(circledBox === 'DoIt'){
    console.log('True Condition');
    canvas.remove(circleimg).renderAll();
    fabric.Image.fromURL(imgurl, function(circleimg) {
      circleimg.set({ crossOrigin: 'anonymous' });
      circleimg.set({
        left: img.left,
        top: img.top,
        originX: 'center',
        originY: 'center'
      });
      circleimg.scaleToHeight(available_height);
      circleimg.clipPath = circleClip;
      canvas2.add(circleimg);
      window['text1Page'].bringToFront();
      img = circleimg;
      canvas.renderAll();
    }, { crossOrigin: 'anonymous' });
  }else{
    console.log('Rest Condition');
    fabric.Image.fromURL(imgurl, function(newImg){
      newImg.set({
        left: img.left,
        top: img.top,
        selectable: img.selectable
      });
      newImg.scaleToHeight(available_height);
      canvas.add(newImg).renderAll();
      window['text1Page'].bringToFront();
      img = newImg;
      canvas.renderAll();
    }, { crossOrigin: 'anonymous' });
  }
}

function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});

document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){
  loader.removeClass('hidden');
  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');
  img = window[jQuery(this).attr('data-obj')];
  canvas = window[jQuery(this).attr('data-canvas')];
  available_height = jQuery(this).attr('data-height');
  circledBox = jQuery(this).attr('data-circle');
  jQuery('#tadaWidget').addClass('hidden');
  setTimeout(function(){
    cropper.destroy();
    jQuery('#blah').attr('src',imgurl);
    initCropper();
    jQuery('.popupImg').show();
    loader.addClass('hidden');
  },150);
});

jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas'),
      textOb = jQuery(this).attr('data-obj');
  canvas = window[fontID];
  activeOb = window[textOb];
  activeOb.set({ fontFamily: this.value });
  canvas.renderAll();
  fitTextToWidth(window['text1Page'], 340);
  fitTextToBox(window['text2Page'], maxWidth, maxHeight);
});

function updateFont(activeOb,family,size,fill){
  if(activeOb){
    if(family == ''){
      family = activeOb.fontFamily;
    }
    if(size == ''){
      size = activeOb.fontSize;
    }
    if(fill == ''){
      fill = activeOb.fill;
    }
    sCAle = activeOb.scaleX;
    activeOb.set('fontSize',size);
    activeOb.set('fontFamily',family);
    activeOb.set('fill',fill);
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
  }
}

function loadColorPicker(colorBox){
  jQuery('#'+colorBox).colorpicker({
    inline: true,
    container: true,
    extensions:[{
      name: 'swatches',
      options:{
        colors:{
          'tetrad1': 'transparent',
          'tetrad2': '#e30405',
          'tetrad3': '#197b30',
          'tetrad4': '#0054a5',
          'tetrad5': '#ffcc00',
          'tetrad6': '#f6ebbe',
          'tetrad7': '#ffea00',
          'tetrad8': '#f8931d',
          'tetrad9': '#f499c2',
          'tetrad10': '#959595',
          'tetrad11': '#fef335',
          'tetrad12': '#a0400d',
          'tetrad13': '#000000',
          'tetrad14': '#604973',
          'tetrad15': '#afe8fc',
          'tetrad16': '#fffafa',
          'tetrad17': '#bc8cbe',
          'tetrad18': '#ff69b4',
          'tetrad19': '#93278f',
          'tetrad20': '#009987',
          'tetrad21': '#0af447',
          'tetrad22': '#00008b',
          'tetrad23': '#006400'
        },
        namesAsValues: false
      }
    }],
    template: '<div class="colorpicker">' +
      '<div class="colorpicker-saturation"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-hue"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-alpha">' +
      '   <div class="colorpicker-alpha-color"></div>' +
      '   <i class="colorpicker-guide"></i>' +
      '</div>' +
      '<div class="colorpicker-bar">' +
      '   <a href="javascript:void(0);" class="button btn-block colorOFF">Ok</a>'+
      '   <div class="ctn-icon-eyedropper dropper-eyedrop"><svg class="icon icon-eyedropper" viewBox="0 0 16 16">'+
      '   <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5'+
      '   0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207'+
      '   1.207 0 0 0 0-1.708zM2 12.707l7-7L10.293 7l-7 7H2z"/></svg></div>'+
      '</div>' +
      '</div>'
  }).on('colorpickerCreate', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('id'),
        active = colorBox.find('.currentColor'),
        activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
    },200);
  }).on('colorpickerChange', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('data-canvas'),
          textOb = colorBox.attr('data-obj'),
          active = colorBox.find('.currentColor'),
          activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
      colorBox.attr('data-color',activeCOLOR);
      canvas = window[colorID];
      activeOb = window[textOb];
      sCAle = activeOb.scaleX;
      activeOb.set('fill',activeCOLOR);
      activeOb.scaleX = .5;
      activeOb.setCoords();
      canvas.renderAll();
      activeOb.scaleX = sCAle;
      activeOb.setCoords();
      canvas.renderAll();
    },200);
  });
  jQuery(document).on('click','.colorBox',function(){
    jQuery('.colorBox').each(function(){
      jQuery(this).next().hide();
    });
    jQuery(this).next().show();
  });
  jQuery(document).on('click','.colorOFF',function(){
    var parENt = jQuery(this).parent().parent(),
        toolBarBox = parENt.parent().parent().parent().attr('id');
    if(toolBarBox === 'labelBase'){
      parENt.parent().parent().parent().parent().removeClass('active');
    }else{
      parENt.hide();
    }
  });
}

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});


jQuery(window).on('load',function(){
  canvasBlock(canvas2);
  window['text1Page'].set('text','Hassan Minhas');
  window['text2Page'].set('text','My First Year\n28-02-2024');
  window['canvas2'].renderAll();
  // loadFirstImg();
});


function getCookie(name){
  let nameEQ = name + "=";
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++){
    let cookie = cookies[i].trim();
    if(cookie.indexOf(nameEQ) === 0){
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

window.addEventListener("load", function(){
  if(getCookie("firstVisit")){
    console.log("✅ Cookie exists:", getCookie("firstVisit"));
  } else{
    console.log("❌ Cookie does not exist!");
    document.cookie = "firstVisit=lamaPao; expires=" + new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/;";
    location.reload();
  }
});



async function handleUpload(fileInputs,timeID){
  const temp_images = [];
  
  for (let input of fileInputs){
    const file = input.files[0]; // Only first file per input
    const croppedURL = jQuery(input).attr('data-cropped');
    if(croppedURL != ''){
      temp_images.push(croppedURL);
    }
    if(file){
      const base64 = await toBase64(file); // ✅ now safely inside async
      temp_images.push(base64);
    }
  }
  if(temp_images.length === 0){
    alert("Please select at least one image.");
    return;
  }
  const payload = {
    timeId: timeID,
    temp_images: temp_images
  };
  console.log(payload);
  try {
    const response = await fetch('//technology-architects.com/tasweer-modules/upload_client_img.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    const result = await response.json();
    console.log("Upload result:", result);
    var int = 1, wall = 1, upCrop;
    result.uploaded_images.forEach(img => {
      if(jQuery('#image'+int).length < 1){
        if (int % 2 === 0) {
          upCrop = 'User Uploaded ';
        }else{
          upCrop = 'Cropped ';
        }
        jQuery('#preview').append('<input type="hidden" id="image'+int+'" name="properties['+ upCrop + wall+']">');
        if(upCrop == 'User Uploaded '){
          wall += 1;
        }
      }
      if (img.status === "success") {
        jQuery('#image'+int).val(img.image_url);
        int += 1;
      } else {
        console.warn("Upload failed:", img.error);
      }
    });
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    loader.addClass('hidden');
  } catch (error) {
    console.error("Upload error:", error);
    alert("Upload failed.");
  }
}

// ✅ Convert a file to base64 string
function toBase64(file){
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

/* fetch Call */
var size,thumbnail;
var loadedObject,enterName,choose_font,mainQuote,chooseFont2,additionalInfo,frameColor, wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 350;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    window['canvas2'] = canvas.toDataURL('image/png');
    enterName = jQuery('.enter_name input').val();
    choose_font = jQuery('.choose_font option:selected').val();
    mainQuote = jQuery('.main_quote textarea').val();
    chooseFont2 = jQuery('.choose_font2 option:selected').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    frameColor = jQuery('.frameColorBox').val();
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#enterName').val(enterName);
      jQuery('#choose_font').val(choose_font);
      jQuery('#mainQuote').val(mainQuote);
      jQuery('#chooseFont2').val(chooseFont2);
      jQuery('#addInfo').val(additionalInfo);
      jQuery('#selected_frameColor').val(frameColor);
      //console.log('Server response:', data);
      const fileInputs = document.querySelectorAll('.upload_image input[type="file"]');
      handleUpload(fileInputs,previewId);
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});

function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}
function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}